import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Table } from "primeng/table";
import { UtilStorageService } from "src/app/admihair/service/util-storage.service";
import { Empresa } from "src/app/admihair/api/dto/empresa";
import { IndicadorClienteService } from "src/app/admihair/service/indicador-cliente.service";
import { IndicadorCliente } from "src/app/admihair/api/dto/indicador-cliente";
import { ConfirmationService, Message } from "primeng/api";
import { ErroService } from "src/app/admihair/service/erro.service";
import { AuthUtil } from "src/app/admihair/util/auth-util";
import { catchError, finalize, of, tap } from "rxjs";

@Component({
  selector: "app-indicador-cliente-listar",
  templateUrl: "./indicador-cliente-listar.component.html",
  styleUrls: ["./indicador-cliente-listar.component.scss"],
})
export class IndicadorClienteListarComponent implements OnInit {
  @ViewChild("filter") filter!: ElementRef;
  permissaoListar: boolean = false;
  permissaoInserir: boolean = false;
  permissaoEditar: boolean = false;
  permissaoExcluir: boolean = false;
  loadingIndicadores: boolean = true;
  indicadoresCliente: IndicadorCliente[] = [];
  messages: Message[] = [];
  messagemVisivel: boolean = false;

  constructor(
    private indicadorClienteService: IndicadorClienteService,
    private utilStorageService: UtilStorageService,
    private confirmationService: ConfirmationService,
    private erroService: ErroService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.verificarPermissoes();
    if (this.permissaoListar) {
      this.listarIndicadorCliente();
    }
  }

  listarIndicadorCliente() {
    const empresaSelecionada: Empresa = this.utilStorageService.getEmpresa();
    this.indicadorClienteService
      .listarIndicadoresClientesPorEmpresa(empresaSelecionada.id)
      .pipe(
        catchError(err => {
          this.messages = this.erroService.handleErro(err);
          this.messagemVisivel = true;
          return of([]);
        }),
        finalize(() => this.loadingIndicadores = false)
      )
      .subscribe((data: IndicadorCliente[]) => this.indicadoresCliente = data);
  }

  buscar(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, "contains");
  }

  limpar(table: Table) {
    table.clear();
    this.filter.nativeElement.value = "";
  }

  excluir(indicadorId: number) {
    this.confirmationService.confirm({
      message: "Tem certeza que deseja excluir?",
      header: "Confirmação",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      icon: "pi pi-info-circle",
      accept: () => {
        this.indicadorClienteService.excluir(indicadorId).subscribe(
          (data) => {
            this.loadingIndicadores = true;
            this.listarIndicadorCliente();
            this.messages = this.erroService.handleSuccess();
            this.messagemVisivel = true;
          },
          (error) => {
            this.messages = this.erroService.handleErro(error);
            this.messagemVisivel = true;
          }
        );
      },
    });
  }

  editarIndicadorCliente(id: number) {
    this._router.navigate(["/apps/indicador-cliente/editar/" + id], {
      relativeTo: this._activatedRoute,
    });
  }

  verificarPermissoes() {
    this.permissaoListar = AuthUtil.verificarPermissao("PERM_LISTAR_CANAL_DE_INDICACAO");
    this.permissaoInserir = AuthUtil.verificarPermissao("PERM_INSERIR_CANAL_DE_INDICACAO");
    this.permissaoEditar = AuthUtil.verificarPermissao("PERM_EDITAR_CANAL_DE_INDICACAO");
    this.permissaoExcluir = AuthUtil.verificarPermissao("PERM_EXCLUIR_CANAL_DE_INDICACAO");
  }
}
